import React from "react";
import ReactDOM from "react-dom/client";
import App from "../src/app/App";
import LoadingProvider from "./contexts/useLoadingContext";
import store from "../src/features/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import "./app/i18n";
import "@fontsource/roboto";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/500.css";
import "./styles/index.scss";

const queryClient = new QueryClient();
const rootContainer = document.getElementById("root");
const root = ReactDOM.createRoot(rootContainer);
root.render(
    <BrowserRouter>
        <QueryClientProvider client={queryClient}>
            <LoadingProvider>
                <Provider store={store}>
                    <App />
                </Provider>
            </LoadingProvider>
        </QueryClientProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
